import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function PrimaryCalendar(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          d="M6 33.9312V39.4739C6 40.1439 6.26615 40.7865 6.73991 41.2602C7.21366 41.734 7.85622 42.0001 8.52621 42.0001H39.4738C40.1438 42.0001 40.7863 41.734 41.2601 41.2602C41.7338 40.7865 42 40.1439 42 39.4739V33.9312H6Z"
          fill="#4383CC"
        />
        <path d="M36.4138 39.5173L42 33.9311V15.3104H6V39.4738L36.4138 39.5173Z" fill="#D4E3F3" />
        <path d="M36.4138 33.9312H42.0001L36.4138 39.5174V33.9312Z" fill="#A1C1E6" />
        <path
          d="M38.2759 9.10347H9.72414C8.73643 9.10347 7.78919 9.49583 7.09077 10.1942C6.39236 10.8927 6 11.8399 6 12.8276V16.7752H42V12.8276C42 11.8399 41.6076 10.8927 40.9092 10.1942C40.2108 9.49583 39.2636 9.10347 38.2759 9.10347Z"
          fill="#A1C1E6"
        />
        <path
          d="M15.9937 6.00001C15.7815 5.99919 15.5713 6.04037 15.3751 6.12118C15.179 6.20199 15.0008 6.32083 14.8507 6.47085C14.7007 6.62087 14.5819 6.7991 14.5011 6.99526C14.4203 7.19143 14.3791 7.40165 14.3799 7.61381V11.0338C14.4054 11.4437 14.5861 11.8285 14.8854 12.1097C15.1847 12.391 15.5799 12.5476 15.9906 12.5476C16.4013 12.5476 16.7965 12.391 17.0958 12.1097C17.395 11.8285 17.5758 11.4437 17.6013 11.0338V7.61381C17.6021 7.40217 17.5611 7.19246 17.4807 6.9967C17.4003 6.80094 17.282 6.62299 17.1326 6.47306C16.9833 6.32312 16.8058 6.20415 16.6103 6.12297C16.4149 6.0418 16.2053 6.00001 15.9937 6.00001ZM32.0137 6.00001C31.8015 5.99919 31.5913 6.04037 31.3951 6.12118C31.199 6.20199 31.0208 6.32083 30.8707 6.47085C30.7207 6.62087 30.6019 6.7991 30.5211 6.99526C30.4403 7.19143 30.3991 7.40165 30.3999 7.61381V11.0338C30.4254 11.4437 30.6061 11.8285 30.9054 12.1097C31.2047 12.391 31.5999 12.5476 32.0106 12.5476C32.4213 12.5476 32.8165 12.391 33.1158 12.1097C33.415 11.8285 33.5958 11.4437 33.6213 11.0338V7.61381C33.6221 7.40217 33.5811 7.19246 33.5007 6.9967C33.4203 6.80094 33.302 6.62299 33.1526 6.47306C33.0033 6.32312 32.8258 6.20415 32.6303 6.12297C32.4349 6.0418 32.2253 6.00001 32.0137 6.00001Z"
          fill="#0E4686"
        />
        <path
          d="M15.2539 19.4316H19.2015V23.3792H15.2539V19.4316ZM22.0256 19.4316H25.9732V23.3792H22.0256V19.4316ZM28.7974 19.4316H32.7449V23.3792H28.7974V19.4316Z"
          fill="#4383CC"
        />
        <path d="M35.5701 19.4315H39.5177V23.3791H35.5701V19.4315Z" fill="#0E4686" />
        <path
          d="M8.4834 26.2593H12.431V30.2069H8.4834V26.2593ZM15.2551 26.2593H19.2027V30.2069H15.2551V26.2593Z"
          fill="#4383CC"
        />
        <path d="M22.0254 26.2593H25.973V30.2069H22.0254V26.2593Z" fill="#0E4686" />
        <path
          d="M28.7986 26.2593H32.7462V30.2069H28.7986V26.2593ZM35.5703 26.2593H39.5179V30.2069H35.5703V26.2593ZM8.4834 33.0869H12.431V37.0345H8.4834V33.0869ZM15.2551 33.0869H19.2027V37.0345H15.2551V33.0869ZM22.0268 33.0869H25.9744V37.0345H22.0268V33.0869Z"
          fill="#4383CC"
        />
      </svg>
    </IconContainer>
  )
}
